import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { to: "/", label: "الرئيسية", testid: "nav-link-home" },
  { to: "/properties", label: "العقارات", testid: "nav-link-properties" },
  { to: "/projects", label: "المشاريع", testid: "nav-link-projects" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 glass" data-testid="main-navbar">
      <div className="container-lux flex items-center justify-between py-4">
        <Link to="/" aria-label="نموذج عقاري — الرئيسية">
          <Logo />
        </Link>
        <nav className="hidden md:flex items-center gap-8" aria-label="التنقل الرئيسي">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `font-heading text-sm font-semibold transition-colors duration-300 ${
                  isActive ? "text-gold-dark" : "text-forest hover:text-gold-dark"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/request" className="btn-gold !py-2.5 !px-6 text-sm" data-testid="nav-cta-request">
            اطلب عقارك
          </Link>
        </nav>
        <button
          className="md:hidden text-forest p-2"
          onClick={() => setOpen(!open)}
          aria-label={open ? "إغلاق القائمة" : "فتح القائمة"}
          data-testid="mobile-menu-button"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden border-t border-forest/10 bg-white/95 backdrop-blur-xl"
            aria-label="قائمة الجوال"
          >
            <div className="container-lux flex flex-col gap-1 py-4" key={location.pathname}>
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-${l.testid}`}
                  className="py-3 font-heading font-semibold text-forest border-b border-forest/5"
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/request"
                onClick={() => setOpen(false)}
                className="btn-gold mt-3 text-sm"
                data-testid="mobile-nav-cta-request"
              >
                اطلب عقارك
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
